// extracted by mini-css-extract-plugin
module.exports = {"panel":"panel___J7l3I"};